<template>
  <div>
    <DxForm id="formularioUsuario" ref="formInstance" :form-data="model" label-location="top"
      :show-colon-after-label="false" :visible="model != null" validation-group="validacionAgente">
      <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

      <!-- Grupo 1: Datos Personales -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem data-field="Nombre" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('agentes_inmobiliaria.form.nombre')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.nombre')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Apellidos" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('agentes_inmobiliaria.form.apellidos')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.apellidos')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Email" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('agentes_inmobiliaria.form.email')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.email')" />
          <DxEmailRule :message="$t('agentes_inmobiliaria.form.validacion.email_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Documento" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('agentes_inmobiliaria.form.dni_nie')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.dni_nie')" />
          <DxPatternRule :pattern="dniNieNifPattern"
            :message="$t('agentes_inmobiliaria.form.validacion.dni_nie_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="IdCometido" editor-type="dxSelectBox" :col-span="3"
          :editor-options="{ ...getSelectBoxDefaultProperties(), ...selectCometidoAgenteInmobiliariaOptions }">
          <DxLabel :text="$t('agentes_inmobiliaria.form.cometido')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.cometido')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Telefono" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('agentes_inmobiliaria.form.telefono')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.telefono')" />
          <DxPatternRule :pattern="telefonoPattern"
            :message="$t('agentes_inmobiliaria.form.validacion.telefono_patron')" />
        </DxSimpleItem>
        <DxSimpleItem :visible="showDelegacionSb" data-field="IdsDelegacionInmobiliaria" editor-type="dxTagBox" :col-span="3"
          :editor-options="{ ...getSelectBoxDefaultProperties(), ...tagBoxDelegacionInmobiliariaOptions }">
          <DxLabel :text="$t('agentes_inmobiliaria.form.delegacion_inmobiliaria')" />
          <DxCustomRule :validation-callback="validateDelegacionInmobiliaria"
            :message="$t('agentes_inmobiliaria.form.validacion.tipo')" />
        </DxSimpleItem>
        <DxEmptyItem :visible="!showDelegacionSb" :col-span="3" />
        <DxEmptyItem :col-span="3" />
      </DxGroupItem>

      <!-- Grupo 2: Dirección -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{
            $t('agentes_inmobiliaria.form.direccion_fisica')
          }}</span>
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.CodigoPostal" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('agentes_inmobiliaria.form.codigo_postal')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.codigo_postal')" />
          <DxPatternRule :pattern="codigoPostalPattern"
            :message="$t('agentes_inmobiliaria.form.validacion.codigo_postal_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Provincia" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('agentes_inmobiliaria.form.provincia')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.provincia')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Municipio" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('agentes_inmobiliaria.form.municipio')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.municipio')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.TipoVia" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('agentes_inmobiliaria.form.tipo_de_via')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.tipo_de_via')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.NombreVia" editor-type="dxTextBox" :col-span="4">
          <DxLabel :text="$t('agentes_inmobiliaria.form.nombre_via')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.nombre_via')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Numero" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('agentes_inmobiliaria.form.numero')" />
          <DxRequiredRule :message="$t('agentes_inmobiliaria.form.validacion.numero')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Escalera" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('agentes_inmobiliaria.form.escalera')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Piso" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('agentes_inmobiliaria.form.piso')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Puerta" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('agentes_inmobiliaria.form.puerta')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2">
        </DxEmptyItem>
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script setup lang="ts">
import { messageBoxResult } from '@components/dialogs/message-box';
import type { SelectBoxEntityModel } from '@api/api';
import { useModalBuilder, type ToolbarReference } from '@helpers/modal-building-helper';
import { DxSelectBox, DxTagBox, type DxButton } from 'devextreme-vue';
import {
  DxEmailRule,
  DxForm,
  DxItem,
  DxLabel,
  DxColCountByScreen,
  DxRequiredRule,
  DxPatternRule,
  DxEmptyItem,
  DxGroupItem,
  DxSimpleItem
} from "devextreme-vue/form";
import { DxCustomRule } from 'devextreme-vue/validator';
import { getCurrentInstance, onBeforeMount, onMounted, reactive, ref, watch } from 'vue';
import { useIntl } from '@services/i18n';
import { getSelectBoxDefaultProperties } from '@helpers/grid-helper';
import validationEngine from "devextreme/ui/validation_engine";
import { useApi } from '@api/integration';
import { toastError, toastSuccess } from '@/.shared/services/notification-service';
import { ApiError } from '@/.shared/services/http';
import { UNABLE_TO_CHANGE_USER_TYPE, USER_WITH_DUPLICATED_EMAIL } from '@/.shared/errors/codes';
import type { CreateAgenteInmobiliaria, EditAgenteInmobiliaria } from './models/CreateAgenteInmobiliaria';
import { CometidoAgenteInmobiliariaEnum } from '@api/api';

const api = useApi();
const intl = useIntl();

const props = defineProps({
  model: {
    type: Object as () => CreateAgenteInmobiliaria | EditAgenteInmobiliaria,
    required: false
  },
  isEditMode: {
    type: Boolean,
    required: true
  }
});

const formInstance = ref<DxForm>();
const selectCometidoAgenteInmobiliariaOptions = reactive<DxSelectBox>({ displayExpr: "TranslatedText" });
const tagBoxDelegacionInmobiliariaOptions = reactive<DxTagBox>({});

const telefonoPattern = ref<RegExp>(/^\d{9}$/);
const codigoPostalPattern = ref<RegExp>(/^\d{5}$/);
const dniNieNifPattern = ref<RegExp>(/(^\d{8}[A-Za-z]$)|(^[A-Za-z]\d{7}[A-Za-z0-9]$)/);

const showDelegacionSb = ref<boolean>(true);

watch(
  () => props.model?.IdCometido,
  (newValue) => {
    if (newValue == undefined || newValue === CometidoAgenteInmobiliariaEnum.Director) {
      showDelegacionSb.value = false;
      props.model!.IdsDelegacionInmobiliaria = [];
    }
    else
      showDelegacionSb.value = true;
  },
  { immediate: true }
);

onBeforeMount(async () => {
  await selectCometidoAgenteInmobiliariaDatasource();
  await setDelegacionInmobiliariaDatasource();
});

onMounted(async () => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!);
  configureButtons(modal);
});

async function selectCometidoAgenteInmobiliariaDatasource() {
  const cometidos = await api.callStandardApi("getCometidoAgentesInmobiliariaSelector", { showLoading: false });
  selectCometidoAgenteInmobiliariaOptions.dataSource = cometidos.map((c: SelectBoxEntityModel) => ({
    ...c,
    TranslatedText: intl.i18n.t(`agentes_inmobiliaria.cometidos.${c.Id}`)
  }));
}

async function setDelegacionInmobiliariaDatasource() {
  tagBoxDelegacionInmobiliariaOptions.dataSource = await api.callStandardApi("getDelegacionInmobiliariaSelector", { showLoading: false });
}

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;
  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());
  okButton.update(w => w.text = `${intl.i18n.t("shared.ui.buttons.save")}`);
  okButton.update(w => w.onClick = async () => {
    saveOrEdit().then((value) => {
      if (value)
        modal.close(messageBoxResult.ok)
    });
  }
  );
  cancelButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
}

async function saveOrEdit() {
  var res = validationEngine.validateGroup("validacionAgente");

  if (res.isValid) {
    if (props.isEditMode) {
      try {
        await api.callStandardApi("editAgenteInmobiliaria", { showLoading: true }, props.model as EditAgenteInmobiliaria)
          .then(() => toastSuccess(intl.i18n.t('agentes_inmobiliaria.edicion_exito')));
      }
      catch (e: any) {
        if (e instanceof ApiError && e.details?.errorList.length === 1 && [USER_WITH_DUPLICATED_EMAIL, UNABLE_TO_CHANGE_USER_TYPE].includes(e.details.errorList[0].Code)) {
          toastError(intl.i18n.t(`shared.errors.api.${e.details.errorList[0].Code}`))
        }
        else throw e;
        return false;
      }
    } else {
      try {
        await api.callStandardApi("createAgenteInmobiliaria", { showLoading: true }, props.model as CreateAgenteInmobiliaria)
          .then(() => toastSuccess(intl.i18n.t('agentes_inmobiliaria.creacion_exito')));
      }
      catch (e: any) {
        if (e instanceof ApiError && e.details?.errorList.length === 1 && [USER_WITH_DUPLICATED_EMAIL].includes(e.details.errorList[0].Code)) {
          toastError(intl.i18n.t(`shared.errors.api.${e.details.errorList[0].Code}`))
        }
        else throw e;
        return false;
      }
    }
    return true;
  } else {
    toastError(intl.i18n.t('agentes_inmobiliaria.revise_validacion'));
  }

  return false;
}

function validateDelegacionInmobiliaria(e: any) {
  switch (props.model!.IdCometido) {
    case CometidoAgenteInmobiliariaEnum.Coordinador:
      return e.value.length > 0;
    case CometidoAgenteInmobiliariaEnum.Agente:
      return e.value.length === 1;
    case CometidoAgenteInmobiliariaEnum.Director:
      return e.value.length === 0;
    default:
      return false;
  }
}
</script>